export const defaultStyle = `
	label {
        font-weight: 600;
    }
    i { 
        top: auto;
    }
`;
